import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, ViewController } from 'ionic-angular';
import {
  Validators,
  FormBuilder,
  FormGroup,
  FormControl
} from "@angular/forms";
import { Observable } from "rxjs/Observable";
import { AppConfig } from "../../providers/config";
import * as moment from "moment";
import { AuthProvider } from '../../providers/auth/auth';
import { DatabaseProvider } from '../../providers/database/database';
import { ENV } from '@app/env'

@IonicPage()
@Component({
  selector: 'page-admin-users-add',
  templateUrl: 'admin-users-add.html',
})
export class AdminUsersAddPage {
  user: any = {};
  program_selected: any = {};
  public programList: Observable<any[]>;

  first_name: FormControl;
  last_name: FormControl;
  email: FormControl;
  phone_number: FormControl;
  password: FormControl;
  // program: FormControl;
  navigator_admin: FormControl;
  navigator_ncm: FormControl;
  navigator_rcm: FormControl;
  clinic_tester: FormControl;
  program_admin: FormControl;

  constructor(public viewCtrl: ViewController, private database: DatabaseProvider, public params: NavParams, public navCtrl: NavController, public navParams: NavParams, private formBuilder: FormBuilder, private auth: AuthProvider, public loadingCtrl: LoadingController) {
    this.programList = params.get('programs'); 

    this.auth.getUserToken().then((token) => {
      // console.log('User Token: ', token);
    });

    this.first_name = new FormControl(
      "",
      Validators.compose([
        Validators.maxLength(30),
        Validators.pattern("[a-zA-Z -]*"),
        Validators.required
      ])
    );
    this.last_name = new FormControl(
      "",
      Validators.compose([
        Validators.maxLength(30),
        Validators.pattern("[a-zA-Z -]*"),
        Validators.required
      ])
    );
    this.email = new FormControl(
      "",
      Validators.compose([
        Validators.pattern("^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$")
      ])
    );
    this.password = new FormControl(
      "",
      Validators.compose([
        Validators.minLength(8),
        Validators.maxLength(30),
        Validators.pattern("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$"),
        Validators.required
      ])
    );
    this.phone_number = new FormControl("", Validators.required);
  // this.program = new FormControl("");

    this.user = formBuilder.group({
      first_name: this.first_name,
      last_name: this.last_name,
      email: this.email,
      phone_number: this.phone_number,
      password: this.password,
      navigator_admin: this.navigator_admin,
      program_admin: this.program_admin,
      clinic_tester: this.clinic_tester,
      navigator_ncm: this.navigator_ncm,
      navigator_rcm: this.navigator_rcm,
      // program: this.program
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AdminUsersAddPage');
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  showProgram(ev, program)  {
    this.program_selected = program;
  }

  createUser()  {
    let new_user = this.user.value;
    new_user['program_id'] = ENV.PROGRAM_ID;
    new_user['program_name'] = ENV.PROGRAM_NAME;
    if(new_user['navigator_admin'] === null) new_user['navigator_admin'] = false;
    if(new_user['navigator_ncm'] === null) new_user['navigator_ncm'] = false;
    if(new_user['navigator_rcm'] === null) new_user['navigator_rcm'] = false;
    if(new_user['program_admin'] === null) new_user['program_admin'] = false;
    console.log('Creating new user: ', new_user);
    const loader = this.loadingCtrl.create({
      content: "Creating User..."
    });

    loader.present()
    this.database.createUser(new_user).then((result) => {
      loader.dismiss().then(() => {
        console.log('create user: ', result);
        this.dismiss();
      })
      

    })
    .catch((error) => {
      loader.dismiss();
      console.log('create user error: ', error);
    })
  }

}



// WEBPACK FOOTER //
// ./src/pages/admin-users-add/admin-users-add.ts